import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { jsx as _jsx } from "react/jsx-runtime";
const DateTableCell = ({
  testId,
  value
}) => /*#__PURE__*/_jsx("td", {
  "data-test-id": testId,
  children: value ? /*#__PURE__*/_jsx(FormattedDateTime, {
    format: "ll",
    type: "utc",
    value: value
  }) : '--'
});
export default DateTableCell;